import { gql, useMutation } from '@apollo/client';

const INSERT_TICKET_COMMENT = gql`
  mutation InsertTicketComment($ticketId: Uuid = "", $updatedBy: Int4 = "", $comment: Text = "") {
    v2InsertTicketUpdates(
      objects: {comment: $comment, ticketId: $ticketId, updatedBy: $updatedBy}
    ) {
      affectedRows
    }
  }
`;

const useInsertTicketComment = () => {
    const [insertTicketComment, { loading, error }] = useMutation(INSERT_TICKET_COMMENT, {
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        }
    });

    return { insertTicketComment, loading, error };
}

export default useInsertTicketComment;
